import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from '@/App';
import '@/index.scss';
import { Provider, store } from '@ax/redux-store';
import { API } from '@ax/api';
import { PROJECT_ENVIRONMENT } from '@ax/env';
import { AuthenticationProvider } from './contexts/AuthenticationProvider';

API.config(PROJECT_ENVIRONMENT?.API);

Sentry.init({
  dsn: 'https://61a9cd0ac6d586e0407b3c17e40feaf0@o4504923185020928.ingest.us.sentry.io/4508723605929985',
  environment: process.env.APP_ENV,
  integrations: [Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration()],
  normalizeDepth: 10,
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthenticationProvider>
        <App />
      </AuthenticationProvider>
    </Provider>
  </React.StrictMode>,
);
